export default __webpack_public_path__ + "static/media/sign_language_research_center.c4b01678.svg";